import { render, staticRenderFns } from "./Pause.vue?vue&type=template&id=ddb79f8a&scoped=true"
import script from "./Pause.vue?vue&type=script&lang=js"
export * from "./Pause.vue?vue&type=script&lang=js"
import style0 from "./Pause.vue?vue&type=style&index=0&id=ddb79f8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb79f8a",
  null
  
)

export default component.exports